// MARK:- Custom full-window mobile menu JavaScript
(() => {
  const menu = document.querySelector('.custom-mobile-menu');
  const toggle = document.querySelector('.custom-mobile-menu-toggle');
  const closeBtn = document.querySelector('.custom-mobile-menu__close');

  if (!menu || !toggle) return;

  const open = () => {
    menu.classList.add('is-open');
    menu.setAttribute('aria-hidden', 'false');
    document.body.classList.add('custom-mobile-menu-open');
    toggle.setAttribute('aria-expanded', 'true');
    closeBtn?.focus();

    // Dispatch event for other scripts to listen
    document.dispatchEvent(new CustomEvent('custom-mobile-menu:open'));
  };

  const close = () => {
    menu.classList.remove('is-open');
    menu.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('custom-mobile-menu-open');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.focus();

    // Dispatch event for other scripts to listen
    document.dispatchEvent(new CustomEvent('custom-mobile-menu:close'));
  };

  toggle.addEventListener('click', () => {
    menu.classList.contains('is-open') ? close() : open();
  });

  closeBtn?.addEventListener('click', close);

  document.addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && menu.classList.contains('is-open')) {
      close();
    }
  });

  // Close on click outside menu content (clicking the backdrop)
  menu.addEventListener('click', (e) => {
    if (e.target === menu) close();
  });

  // MARK:- accordion toggle for parent items with children
  menu.addEventListener('click', (event) => {
    const toggle = event.target.closest('.custom-mobile-menu__parent--toggle');
    if (!toggle || !menu.contains(toggle)) return;

    const panelId = toggle.getAttribute('aria-controls');
    const panel = panelId ? document.getElementById(panelId) : null;
    if (!panel) return;

    const isOpen = toggle.getAttribute('aria-expanded') === 'true';
    toggle.setAttribute('aria-expanded', isOpen ? 'false' : 'true');
    if (isOpen) {
      panel.setAttribute('hidden', '');
    } else {
      panel.removeAttribute('hidden');
    }
  });
})();
